import reportConstants from 'constants/report';

const getMaxTransactionInMonthByCompany = () => {
  return window.COMPANY_IN_WEB === window.COMPANY_ID_VNNG
    ? reportConstants.MAX_T_VNNG
    : reportConstants.MAX_T;
};

export default {
  getMaxTransactionInMonthByCompany,
};
